import { render, staticRenderFns } from "./YasashikuteBox.vue?vue&type=template&id=8115b0a0&scoped=true&"
import script from "./YasashikuteBox.vue?vue&type=script&lang=js&"
export * from "./YasashikuteBox.vue?vue&type=script&lang=js&"
import style0 from "./YasashikuteBox.vue?vue&type=style&index=0&id=8115b0a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8115b0a0",
  null
  
)

component.options.__file = "YasashikuteBox.vue"
export default component.exports